import React, { Fragment, useEffect, useRef, useState } from "react";
import { VenueDate } from "../Utils/common";
import { format } from "date-fns";
import DatePicker from "react-horizontal-datepicker";
import { CustomGetAPI, CustomPostAPI } from "../Utils/APIConnector";
import Loader from "../Utils/Loader";
import Swal from "sweetalert2";
import HorizontalDatePicker from "../Components/HorizontalDatePicker";
import VenueOwnerDetailsPopup from "./VenueOwnerDetailsPopup";

export default function VenueOwnerBookingPage({
  setShowoffline,
  VenueId,
  getdata,
}) {
  const [bookingDate, setBookingDate] = useState(new Date());
  const [show, setShow] = useState({ popup: false, data: "", title: "" });
  const [isLoading, setIsLoading] = useState(true);
  const [bookNow, setBookNow] = useState(false);
  const [venueData, setVenueData] = useState();
  const [sportID, setSportID] = useState(0);
  const [surfaceID, setSurfaceID] = useState(0);
  const [venueSlots, setVenueSlots] = useState([]);
  const [bookingDetails, setBookingDetails] = useState({
    name: "",
    phone: "",
    discountAmount: "",
    advanceAmount: "",
  });
  const [suggestions, setSuggestions] = useState([]);
  const suggestionref = useRef(null);
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleClickOutside = (event) => {
    if (
      suggestionref.current &&
      !suggestionref.current.contains(event.target)
    ) {
      setSuggestions([]);
    }
  };
  const [NumberOfPeople, setNumberOfPeopleAttending] = useState(1);
  const [purposeError, setPurposeError] = useState(false);
  const [selectedPurpose, setPurpose] = useState(0);
  const [selectedVenueSlots, setSelectedVenueSlots] = useState([]);
  const [selecedTurf, setSelecedTurf] = useState();
  const userID = localStorage.getItem("userid");

  useEffect(() => {
    if (VenueId) {
      fetchData();
    }
  }, [VenueId]);
  useEffect(() => {
    if (surfaceID && sportID) {
      GetTimeslot();
    }
  }, [bookingDate, sportID, surfaceID]);
  useEffect(() => {
    if (surfaceID) {
      GetSportID();
    }
  }, [surfaceID]);

  async function fetchData() {
    CustomGetAPI("/Venue/GetvenuecitybyID/" + VenueId).then((result) => {
      if (result === undefined || result === "") {
        alert("Something went wrong");
      } else {
        result = JSON.parse(result);
        if (result?.status === "success") {
          CustomGetAPI(
            "/Venue/GetvenuebyID/" +
            result.venuename +
            "/" +
            (userID ? userID : 0)
          ).then((result) => {
            if (result === undefined || result === "") {
              alert("Something went wrong");
            } else {
              result = JSON.parse(result);
              if (result?.status === "Success") {
                setVenueData(result?.venue);
                setSelecedTurf(result?.venue?.venueSurface[0]?.name);
                setSurfaceID(result?.venue?.venueSurface[0]?.id);
              }
            }
          });
        }
      }
    });
  }
  const handleBookingDetails = async (bookingID) => {
    try {
      CustomGetAPI(`/venue/GetBookingDetails/${bookingID}`).then((result) => {
        result = JSON.parse(result);
        if (result?.status == "Success") {
          setShow({
            popup: true,
            data: result?.bookingdetails[0],
            title: "Booking Details",
          });
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
  async function GetTimeslot() {
    let date = new Date(bookingDate);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    setIsLoading(true);
    try {
      await CustomGetAPI(
        `/Venue/GetTimeslots/${VenueId}/${sportID}/${surfaceID}/0/false/true?date=${formattedDate}`
      ).then((result) => {
        if (result === "" || result === undefined) {
          alert("Error");
        } else {
          result = JSON.parse(result);
          setVenueSlots(result);
        }
      });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  async function GetSportID() {
    CustomGetAPI(`/venue/GetsportsBySurface/${surfaceID}`).then((result) => {
      if (result) {
        result = JSON.parse(result);
        if (result?.status == "Success") {
          setSportID(result?.response[0]?.sportId);
        }
      }
    });
  }

  const handleBooking = async (required) => {
    try {
      setIsLoading(true);
      if (required && bookingDetails?.phone?.length < 10) {
        const errorDiv = document.getElementById("selectedtimeslotError");
        errorDiv.textContent = "Phone number required";
        return;
      } else {
        const errorDiv = document.getElementById("selectedtimeslotError");
        errorDiv.textContent = "";
      }
      if (bookingDetails?.phone && bookingDetails?.phone?.length < 10) {
        const errorDiv = document.getElementById("selectedtimeslotError");
        errorDiv.textContent = "Please enter valid number";
        return;
      } else {
        const errorDiv = document.getElementById("selectedtimeslotError");
        errorDiv.textContent = "";
      }

      if (
        bookingDetails?.advanceAmount >
        selectedVenueSlots?.reduce((sum, i) => sum + i.price, 0)
      ) {
        const errorDiv = document.getElementById("advanceError");
        errorDiv.textContent = "Advance amount cannot exceed booking amount";
        return;
      } else {
        const errorDiv = document.getElementById("advanceError");
        errorDiv.textContent = "";
      }
      if (
        bookingDetails?.discountAmount >
        selectedVenueSlots?.reduce((sum, i) => sum + i.price, 0) -
        bookingDetails?.advanceAmount
      ) {
        const errorDiv = document.getElementById("discountError");
        errorDiv.textContent = "Discount amount cannot exceed remaining amount";
        return;
      } else {
        const errorDiv = document.getElementById("discountError");
        errorDiv.textContent = "";
      }

      if (required && venueData?.category === "Events") {
        if (!selectedPurpose || selectedPurpose == 0) {
          setPurposeError(true);
          setIsLoading(false);
          return;
        } else {
          setPurposeError(false);
        }

        if (
          NumberOfPeople <= 0 ||
          NumberOfPeople === "" ||
          NumberOfPeople === undefined ||
          NumberOfPeople === null
        ) {
          setIsLoading(false);
          return;
        }
      }

      var raw = JSON.stringify({
        VenueId: VenueId,
        // SurfaceId: surfaceID,
        venueBookings: selectedVenueSlots.map((slot) => ({
          date: slot.startTime.split("T")[0],
          startTime: slot.startTime.split("T")[1].substring(0, 5),
          endTime: slot.endTime.split("T")[1].substring(0, 5),
          SlotDuration: slot?.length,
          SurfaceId: parseInt(slot?.surfaceId),
          SportId: slot?.sportID,
        })),
        //Date: bookingDate,
        // SportId: sportID,
        BookBy: userID,
        name: bookingDetails?.name,
        Phonenumber: bookingDetails?.phone,
        Email: "",
        userID: userID,
        Duration: 0,
        NoOfPeople: 0,
        Isrepatedbooking: false,
        ReoccurringDuration: 0,
        // Enddate: "",
        Offlinebookingamount: selectedVenueSlots?.reduce(
          (sum, i) => sum + i.price,
          0
        ),
        OfflineAdvanceAmount: parseFloat(bookingDetails?.advanceAmount),
        OfflineDiscountAmount: parseFloat(bookingDetails?.discountAmount),
        auditoriumEventTypeId:
          selectedPurpose > 0 && selectedPurpose !== "" ? selectedPurpose : 0,
        peopleAttending:
          NumberOfPeople > 0 && NumberOfPeople !== "" ? NumberOfPeople : 0,
      });
      CustomPostAPI(`/Venue/Newofflinebooking`, raw).then((result) => {
        if (result === undefined || result === "") {
          alert("Something went wrong");
        } else {
          result = JSON.parse(result);
          if (result?.status === "success") {
            Swal.fire({
              icon: "success",
              title: "Congratulations!",
              text: "Your offline booking is confirmed.",
              showConfirmButton: true,
              confirmButtonText: "Ok",
            }).then((result) => {
              // setShowoffline((prevState) => ({ ...prevState, popup: false }));
              setBookNow(false);
              setSelectedVenueSlots([]);
              GetTimeslot();
              getdata();
              setBookingDetails({
                name: "",
                phone: "",
                discountAmount: "",
                advanceAmount: "",
              });
              // window.location.reload();
            });
          } else if (result?.status === "Error") {
            Swal.fire({
              icon: "error",
              text: result?.message,
              showConfirmButton: true,
              confirmButtonText: "Ok",
            }).then((result) => {
              setBookNow(false);
              GetTimeslot();
              getdata();
              setNumberOfPeopleAttending();
              setPurpose(0);
              setSelectedVenueSlots([]);
              setBookingDetails({
                name: "",
                phone: "",
                discountAmount: "",
                advanceAmount: "",
              });
            });
          }
        }
      });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <VenueOwnerDetailsPopup
        show={show}
        setShow={setShow}
        setisLoading={setIsLoading}
        GetTimeslot={GetTimeslot}
        getdata={getdata}
      />
      {bookNow ? (
        <Fragment>
          {/* <div className="row mx-0 align-items-center">
            <div
              className="col-1"
              onClick={() => {
                if (bookNow) {
                  setBookNow(false);
                } else {
                  setShowoffline((prev) => ({ ...prev, popup: false }));
                }
              }}
            >
              <img
                className="cursor-pointer"
                src="/images/backArrow.svg"
                alt=""
              />
            </div>
            <div className="col-10 text-center fw-bold">Bookings</div>
            <div className="col-1 ps-0"></div>
          </div> */}
          <div className="row mx-0 mt-2">
            {selectedVenueSlots?.map((slot) => (
              <div
                className="col-12 mt-3 d-flex justify-content-between"
                style={{
                  border: "2px solid #EFEFEF",
                  borderRadius: "10px",
                  boxShadow: "0px 5px 20px 0px #ABABAB1A",
                  padding: "10px 15px",
                  fontSize: "12px",
                  color: "#4C4C4C",
                  fontWeight: "500",
                }}
              >
                <div>
                  {VenueDate(slot?.startTime?.split("T")[0]).formattedDate}{" "}
                  <br />({slot?.startTimeString}-{slot?.endTimeString})
                </div>
                <div>
                  RS {slot?.price}
                  <br />
                  {slot?.surfaceName?.split("(")[0]}
                </div>
                <div>
                  <img
                    onClick={() => {
                      setSelectedVenueSlots(
                        selectedVenueSlots.filter(
                          (s) =>
                            !(
                              s.startTime === slot.startTime &&
                              s.surfaceId === slot.surfaceId
                            )
                        )
                      );
                      if (selectedVenueSlots?.length == 1) {
                        setBookNow(false);
                        setSelectedVenueSlots([]);
                        GetTimeslot();
                        setBookingDetails({
                          name: "",
                          phone: "",
                          discountAmount: "",
                          advanceAmount: "",
                        });
                      }
                    }}
                    className="cursor-pointer"
                    src="/images/deleteIcon.svg"
                    alt=""
                  />
                </div>
              </div>
            ))}
          </div>
          <div className="row mx-0 mt-3">
            <div className="col-12 px-0">
              <b>Book by</b>
            </div>
            <div className="col-12 px-0 mt-2">
              <label htmlFor="">Name</label>
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Name"
                value={bookingDetails?.name}
                onChange={(e) => {
                  setBookingDetails((prev) => ({
                    ...prev,
                    name: e.target.value,
                  }));
                }}
              />
            </div>
            <div className="col-12 px-0 mt-2">
              <label htmlFor="">Phone</label>
              <input
                type="number"
                className="form-control"
                name="phone"
                placeholder="Phone Number"
                onChange={(e) => {
                  try {
                    const response = CustomGetAPI(
                      `/user/GetVenueusers/${e.target.value
                      }/null/${localStorage.getItem("userid")}`
                    ).then((result) => {
                      result = JSON.parse(result);
                      setSuggestions(result);
                    });
                    // setSuggestions(data.suggestions);
                  } catch (error) {
                    console.error("Error fetching suggestions:", error);
                  }

                  if (e.target.value.length > 10) {
                    return;
                  }
                  setBookingDetails((prev) => ({
                    ...prev,
                    phone: e.target.value,
                  }));
                }}
                value={bookingDetails?.phone}
              />
              <div
                id="selectedtimeslotError"
                className="selectedtimeslotError text-danger"
              ></div>
              {suggestions.length > 0 && (
                <ul className="suggestions-list w-100 cursor-pointer py-3">
                  {suggestions?.map((suggestion, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        setBookingDetails({
                          ...bookingDetails,
                          name: suggestion?.firstName,
                          phone: suggestion?.phoneNumber,
                        });
                        setSuggestions([]);
                      }}
                    >
                      {suggestion?.phoneNumber}{" "}
                      {suggestion?.firstName && suggestion?.firstName}
                      {index != suggestions.length - 1 && <hr />}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          {venueData?.category === "Events" && (
            <>
              <div className="row mt-3">
                <div className="col-md-6">
                  <span className="venueText mb-2">Purpose</span>
                  <select
                    name="purpose"
                    className="customize-select mt-2"
                    value={selectedPurpose}
                    onChange={(e) => setPurpose(parseInt(e.target.value))}
                  >
                    <option value={0}>-- Select --</option>
                    {venueData?.auditoriumEvents.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  {purposeError && (
                    <small className="text-danger">
                      Please select atleast 1 Purpose from the dropdown list
                    </small>
                  )}
                </div>
                <div className="col-md-6 mt-md-0 mt-3">
                  <span className="venueText mb-2">No of people attending</span>
                  <input
                    style={{ lineHeight: "1.7" }}
                    type="number"
                    name="numberOfPeople"
                    className="form-control custom-placeholder mt-2"
                    min={1}
                    // max={venueData?.data[selectedSurfaceIndex]?.maxcapacity}
                    value={NumberOfPeople === null ? " " : NumberOfPeople}
                    onChange={(e) =>
                      setNumberOfPeopleAttending(
                        e.target.value === "" ? "" : parseInt(e.target.value)
                      )
                    }
                  />
                  {(!NumberOfPeople || NumberOfPeople <= 0) && (
                    <small className="text-danger">
                      Please enter a value greater than 0
                    </small>
                  )}
                </div>
              </div>
            </>
          )}
          <div className="row mx-0 mt-3">
            <div className="col-12 px-0">
              <b>Payment Details</b>
            </div>
            <div className="col-12 px-0 mt-2">
              <label htmlFor="">Advance Amount</label>
              <input
                type="number"
                className="form-control"
                name="advanceAmount"
                placeholder="Advance Booking Amount"
                onChange={(e) => {
                  if (
                    e.target.value >
                    selectedVenueSlots?.reduce((sum, i) => sum + i.price, 0)
                  ) {
                    const errorDiv = document.getElementById("advanceError");
                    errorDiv.textContent =
                      "Advance amount cannot exceed booking amount";
                    return;
                  } else {
                    const errorDiv = document.getElementById("advanceError");
                    errorDiv.textContent = "";
                  }
                  setBookingDetails((prev) => ({
                    ...prev,
                    advanceAmount: e.target.value,
                  }));
                }}
                value={bookingDetails?.advanceAmount}
              />
              <div id="advanceError" className="text-danger"></div>
            </div>
            <div className="col-12 px-0 mt-2">
              <label htmlFor="">Discount Amount</label>
              <input
                type="number"
                className="form-control"
                placeholder="Discount Amount"
                name="discountAmount"
                onChange={(e) => {
                  if (
                    e.target.value >
                    selectedVenueSlots?.reduce((sum, i) => sum + i.price, 0) -
                    bookingDetails?.advanceAmount
                  ) {
                    const errorDiv = document.getElementById("discountError");
                    errorDiv.textContent =
                      "Discount amount cannot exceed remaining amount";
                    return;
                  } else {
                    const errorDiv = document.getElementById("discountError");
                    errorDiv.textContent = "";
                  }
                  setBookingDetails((prev) => ({
                    ...prev,
                    discountAmount: e.target.value,
                  }));
                }}
                value={bookingDetails?.discountAmount}
              />
              <div id="discountError" className="text-danger"></div>
            </div>
          </div>
          <div className="row mx-0 my-3">
            <div className="col-12 text-center">
              <a
                className="me-3"
                style={{ color: "gray" }}
                onClick={() => {
                  setBookNow(false);
                }}
              >
                Cancel
              </a>
              <a
                className="me-3"
                onClick={() => {
                  handleBooking(false);
                }}
              >
                Skip & Book
              </a>
              <button
                className="packageDetailsBtn"
                style={{ fontSize: "14px" }}
                onClick={() => {
                  handleBooking(true);
                }}
              >
                Book Now
              </button>
            </div>
          </div>
        </Fragment>
      ) : (
        <Fragment>
          <div className="row mx-0 align-items-center ">
            {/* <div
              className="col-1"
              onClick={() => {
                setShowoffline((prev) => ({ ...prev, popup: false }));
              }}
            >
              <img
                className="cursor-pointer"
                src="/images/backArrow.svg"
                alt=""
              />
            </div>
            <div className="col-10 text-center fw-bold">New Booking</div>
            <div className="col-1 ps-0">
              <img src="/images/latestCal.svg" alt="" />
            </div> */}
            <div className="col-12 mt-2 px-0">
              <HorizontalDatePicker
                selectedDate={bookingDate}
                setSelectedDate={setBookingDate}
              />
              {/* <DatePicker
                color="#E7666A"
                labelFormat=""
                enableDaysBefore={true}
                getSelectedDay={(val) =>
                  setBookingDate(
                    new Date(val.getFullYear(), val.getMonth(), val.getDate())
                  )
                }
              /> */}
            </div>
            <div
              className={`col-12 px-0 ${venueData?.venueSurface?.length > 1 && "mb-3 mt-2"
                }`}
            >
              <div className={`scrollable-container`}>
                {venueData?.venueSurface?.length > 1 &&
                  venueData?.venueSurface?.map((data) => (
                    <button
                      key={data.id}
                      onClick={() => {
                        setSelecedTurf(data?.name);
                        setSurfaceID(data?.id);
                      }}
                      className={`${selecedTurf?.toLowerCase() === data.name?.toLowerCase()
                          ? "active"
                          : ""
                        } turfBtn me-3 mb-0 Montserrat`}
                    >
                      {data?.name?.split("(")[0]}
                    </button>
                  ))}
              </div>
            </div>
            {/* <div className="col-4 pe-0 mb-3 mt-2 text-end">
              <button
                className="packageDetailsBtn"
                style={{
                  fontSize: "14px",
                  opacity: selectedVenueSlots?.length > 0 ? "1" : "0.7",
                }}
                onClick={() => {
                  if (selectedVenueSlots?.length > 0) {
                    setBookNow(true);
                  }
                }}
              >
                Book Now
              </button>
            </div> */}
          </div>
          <div className="row mx-0 mb-2 gx-2">
            {isLoading ? (
              <>
                <Loader mt="20%" />
              </>
            ) : (
              <>
                <div
                  style={{ position: "fixed", bottom: "10px", right: "10px" }}
                >
                  <div className=" pe-0 mt-2 text-end bottom-0">
                    <button
                      className="packageDetailsBtn px-3"
                      style={{
                        fontSize: "16px",
                        opacity: selectedVenueSlots?.length > 0 ? "1" : "0.7",
                      }}
                      onClick={() => {
                        if (selectedVenueSlots?.length > 0) {
                          setBookNow(true);
                        }
                      }}
                    >
                      Book Now
                    </button>
                  </div>
                </div>
                {venueSlots
                  ?.filter((item) => {
                    const slotDateStr = new Date(
                      item?.startTime?.split("T")[0]
                    );
                    const slotDate =
                      slotDateStr.getFullYear() +
                      "-" +
                      slotDateStr.getMonth() +
                      "-" +
                      slotDateStr.getDate();
                    const bookingDateStr =
                      bookingDate.getFullYear() +
                      "-" +
                      bookingDate.getMonth() +
                      "-" +
                      bookingDate.getDate();
                    return slotDate === bookingDateStr;
                  })
                  ?.map((slot) => (
                    <div className="col-4 text-center mb-3">
                      <div
                        onClick={() => {
                          if (!slot?.booked) {
                            const isAlreadySelected = selectedVenueSlots.some(
                              (s) =>
                                s.startTime === slot.startTime &&
                                s.surfaceId == surfaceID
                            );

                            if (isAlreadySelected) {
                              setSelectedVenueSlots(
                                selectedVenueSlots.filter(
                                  (s) =>
                                    !(
                                      s.startTime === slot.startTime &&
                                      s.surfaceId === surfaceID
                                    )
                                )
                              );
                            } else {
                              const slotWithSurface = {
                                ...slot,
                                surfaceId: surfaceID,
                                surfaceName: selecedTurf,
                                sportID: sportID,
                              };
                              setSelectedVenueSlots([
                                ...selectedVenueSlots,
                                slotWithSurface,
                              ]);
                            }
                          } else {
                            if (slot?.cooldown) {
                              Swal.fire({
                                toast: true,
                                icon: "warning",
                                title: `Cool Down Period`,
                                timer: 3000,
                                showConfirmButton: false,
                                position: "top",
                              });
                            } else {
                              handleBookingDetails(slot?.bookingID);
                            }
                          }
                        }}
                        style={{
                          background: slot?.bookingID ? "#cce8d2ff" : "",
                        }}
                        className={`${selectedVenueSlots.some(
                          (s) =>
                            s.startTime === slot.startTime &&
                            s.surfaceId == surfaceID
                        ) && "Active"
                          } ${slot?.booked && "disabled"
                          } timeSlots p-1 cursor-pointer`}
                      >
                        {slot?.startTimeString} - {slot?.endTimeString}
                        <br />
                        Rs {slot?.price}/-
                      </div>
                    </div>
                  ))}
              </>
            )}
          </div>
        </Fragment>
      )}
    </>
  );
}
